<div class="container">
  <mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Select From Existing">
      <app-template [title]="'Select Patient For Billing'">
        <div class="all" [ngSwitch]="mode">
          <div *ngSwitchCase="'view'">
            <div style="display: flex; flex-direction: row">
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input
                  matInput
                  placeholder="Name"
                  [(ngModel)]="searchText"
                  (ngModelChange)="searchPatient($event)"
                />
              </mat-form-field>
              <span class="form" style="margin-left: 20px">
                <mat-form-field class="size">
                  <mat-label>Start Date</mat-label>
                  <input
                    [(ngModel)]="sd"
                    matInput
                    [matDatepicker]="dob"
                    (dateChange)="startDateChange($event)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="dob"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #dob></mat-datepicker>
                </mat-form-field>
              </span>
              <span class="form" style="margin-left: 20px">
                <mat-form-field class="size">
                  <mat-label>End Date</mat-label>
                  <input
                    [(ngModel)]="ed"
                    matInput
                    [matDatepicker]="end"
                    (dateChange)="endDateChange($event)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="end"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #end></mat-datepicker>
                </mat-form-field>
              </span>
              <button
                (click)="serachAll()"
                mat-raised-button
                color="primary"
                style="height: 35px; margin-top: 20px; margin-left: 20px"
              >
                {{ searchLoad ? "Searching..." : "Search" }}
              </button>
            </div>
            <div *ngIf="isLoading" style="margin-top: 10px" class="spinner">
              <mat-spinner></mat-spinner>
              <div class="space"></div>
            </div>
            <table id="table" *ngIf="!isLoading" style="width: 100%">
              <tr class="back">
                <th>Name</th>
                <th>Sex</th>
                <th>Reg Number</th>
                <th>
                  <!-- <button
                    (click)="exportexcel()"
                    mat-raised-button
                    color="basic"
                  >
                    Export To Excel
                  </button> -->
                  <div class="dropdown">
                    <button class="dropbtn" mat-raised-button>Export To Excel</button>
                    <div class="dropdown-content">
                      <a class="dropdown-item" (click)="exportCurrent()"
                        >Current Page</a
                      >
                      <a class="dropdown-item" (click)="exportAll()"
                        >All Records</a
                      >
                    </div>
                  </div>
                </th>
                <th></th>
              </tr>
              <tr class="td" *ngFor="let patient of emplyees">
                <td>{{ patient.first_name }}</td>
                <td>{{ patient.sex }}</td>
                <td>{{ patient.registration_no }}</td>
                <td>{{ patient.mobile }}</td>
                <td>
                  <div class="dropdown">
                    <button class="dropbtn" mat-raised-button>Actions</button>
                    <div class="dropdown-content">
                      <a
                        class="dropdown-item"
                        (click)="edit(patient)"
                        *ngIf="
                          role == 'Administrator' ||
                          role == 'Front Desk' ||
                          canDiscount.length > 0
                        "
                        >Edit Record</a
                      >
                      <a class="dropdown-item" (click)="editSoc(patient)"
                        >Edit soc</a
                      >
                      <a class="dropdown-item" (click)="bill(patient)"
                        >Bill Patient</a
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div *ngSwitchCase="'edit'">
            <form
              [formGroup]="stateForm"
              (ngSubmit)="onSubmit($event)"
              class="form"
            >
              <fieldset>
                <legend>Primary Details</legend>
                <span class="input" style="position: relative">
                  <div style="position: absolute; top: -50px; left: 0px">
                    {{ sex }}
                  </div>
                  <mat-form-field>
                    <mat-label>Title</mat-label>
                    <mat-select
                      formControlName="title_id"
                      (selectionChange)="slectOnChange($event)"
                      matNativeControl
                      required
                    >
                      <mat-option
                        *ngFor="let title of titles"
                        [value]="title.id"
                      >
                        {{ title.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="
                      formControls.title_id.invalid &&
                      (formControls.title_id.touched ||
                        formControls.title_id.dirty)
                    "
                    class="form-error form-username-error"
                  >
                    <div *ngIf="formControls.title_id.errors.required">
                      This field required
                    </div>
                  </div>
                </span>
                <span class="input" style="position: relative">
                  <mat-form-field>
                    <mat-label>Sex</mat-label>
                    <mat-select formControlName="sex" matNativeControl required>
                      <mat-option value="Male">Male</mat-option>
                      <mat-option value="Female">Female</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="
                      formControls.sex.invalid &&
                      (formControls.sex.touched || formControls.sex.dirty)
                    "
                    class="form-error form-username-error"
                  >
                    <div *ngIf="formControls.sex.errors.required">
                      This field required
                    </div>
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input
                      formControlName="first_name"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      formControls.first_name.invalid &&
                      (formControls.first_name.touched ||
                        formControls.first_name.dirty)
                    "
                    class="form-error form-username-error"
                  >
                    <div *ngIf="formControls.first_name.errors.required">
                      This field required
                    </div>
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Guardian Name</mat-label>
                    <input
                      formControlName="father_name"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <!-- <span class="input">
                            <mat-form-field>
                                <mat-label>Sex</mat-label>
                                <mat-select formControlName="sex" matNativeControl required>
                                  <mat-option  value="M">Male</mat-option>
                                  <mat-option value="F">Female</mat-option>
                                </mat-select>
                              </mat-form-field>
                              <div *ngIf="formControls.sex.invalid && (formControls.sex.touched || formControls.sex.dirty)" class="form-error form-username-error">
                                <div *ngIf="formControls.sex.errors.required">
                                  This field required
                                </div>
                              </div>
                          </span> -->
                <span class="input">
                  <mat-form-field>
                    <mat-label>Marital Status</mat-label>
                    <mat-select
                      formControlName="marital_status"
                      matNativeControl
                      required
                    >
                      <mat-option value="Married">Married</mat-option>
                      <mat-option value="Unmarried">Unmarried</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    *ngIf="
                      formControls.marital_status.invalid &&
                      (formControls.marital_status.touched ||
                        formControls.marital_status.dirty)
                    "
                    class="form-error form-username-error"
                  >
                    <div *ngIf="formControls.marital_status.errors.required">
                      This field required
                    </div>
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Branch Code</mat-label>
                    <mat-select formControlName="Branch_Code" matNativeControl>
                      <mat-option
                        *ngFor="let Branch of Branches"
                        [value]="Branch.Branch_Code"
                      >
                        {{ Branch.Branch_Name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Blood Group</mat-label>
                    <input
                      formControlName="bloodgroup"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field class="size">
                    <mat-label>Date Of Birth</mat-label>
                    <input
                      formControlName="date_of_birth"
                      (dateChange)="DateChange($event)"
                      matInput
                      [matDatepicker]="dob"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dob"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dob></mat-datepicker>
                  </mat-form-field>
                </span>
                <span class="input" style="position: relative">
                  <mat-form-field>
                    <mat-label>Age</mat-label>
                    <input
                      formControlName="age"
                      type="number"
                      (change)="onChange($event)"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                  <div class="float" style="position: relative; width: 3px">
                    {{ date }}
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Age(day)</mat-label>
                    <input
                      formControlName="ageDays"
                      type="number"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Age(month)</mat-label>
                    <input
                      formControlName="ageMonth"
                      type="number"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Address One</mat-label>
                    <input
                      formControlName="local_address1"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Address Two</mat-label>
                    <input
                      formControlName="local_address2"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>City</mat-label>
                    <mat-select formControlName="local_city" matNativeControl>
                      <mat-option
                        *ngFor="let city of cities"
                        [value]="city.name"
                      >
                        {{ city.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>State</mat-label>
                    <mat-select formControlName="local_state" matNativeControl>
                      <mat-option
                        *ngFor="let state of states"
                        [value]="state.name"
                      >
                        {{ state.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Country</mat-label>
                    <mat-select
                      formControlName="local_country"
                      matNativeControl
                    >
                      <mat-option
                        *ngFor="let country of countries"
                        [value]="country.name"
                      >
                        {{ country.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Nationality</mat-label>
                    <mat-select formControlName="nationality" matNativeControl>
                      <mat-option
                        *ngFor="let nation of nations"
                        [value]="nation.name"
                      >
                        {{ nation.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Mobile No</mat-label>
                    <input
                      formControlName="mobile"
                      matInput
                      placeholder=""
                      required
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      formControls.mobile.invalid &&
                      (formControls.mobile.touched || formControls.mobile.dirty)
                    "
                    class="form-error form-username-error"
                  >
                    <div *ngIf="formControls.mobile.errors.required">
                      This field required
                    </div>
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input
                      formControlName="E_mail_address"
                      matInput
                      type="email"
                      placeholder=""
                      required
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Birth Country</mat-label>
                    <input
                      formControlName="country_of_birth"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <!-- <span class="input">
                          <mat-form-field>
                              <mat-label>Status</mat-label>
                              <mat-select formControlName="status" matNativeControl required>
                                <mat-option  value="Active">Active</mat-option>
                                <mat-option value="Inactive">Inactive</mat-option>
                              </mat-select>
                            </mat-form-field>
                        </span> -->
                <span class="input">
                  <mat-form-field>
                    <mat-label>Booking Number</mat-label>
                    <input
                      type="number"
                      formControlName="booking_number"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Bar Code</mat-label>
                    <mat-select formControlName="Barcode_No" matNativeControl>
                      <mat-option
                        *ngFor="let code of barCodes"
                        [value]="code.barcode_no"
                      >
                        {{ code.barcode_no }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>No. of children</mat-label>
                    <input
                      type="number"
                      formControlName="numberOfChildren"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Occupation</mat-label>
                    <input
                      type="text"
                      formControlName="occupation_code"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
              </fieldset>

              <fieldset class="second">
                <legend>Other Information</legend>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Soc</mat-label>
                    <mat-select
                      formControlName="payor_code"
                      matNativeControl
                      required
                    >
                      <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">
                        {{ soc.SOC_NAME }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <!-- <span class="input">
                            <mat-form-field>
                                <mat-label>Car Per</mat-label>
                                <input formControlName="card_per" matInput placeholder="">
                              </mat-form-field>
                          </span> -->
                <span class="input">
                  <mat-form-field>
                    <mat-label>Password</mat-label>
                    <input
                      type="password"
                      formControlName="Password"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      formControls.Password.invalid &&
                      (formControls.Password.touched ||
                        formControls.Password.dirty)
                    "
                    class="form-error form-username-error"
                  >
                    <div *ngIf="formControls.Password.errors.required">
                      This field required
                    </div>
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Ref Dr</mat-label>
                    <input
                      [(ngModel)]="refDrName"
                      (ngModelChange)="refchg($event)"
                      matInput
                      [ngModelOptions]="{ standalone: true }"
                      required
                    />
                    <div class="float" style="position: relative; width: 3px">
                      <div class="ret" *ngIf="drVisible">
                        <div
                          class="list"
                          (click)="setRefDr(dr)"
                          *ngFor="let dr of searchRef"
                        >
                          {{ dr.Acount_Name }}
                        </div>
                      </div>
                    </div>
                  </mat-form-field>
                </span>
                <mat-divider></mat-divider>

                <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                    <p>{{ Errors }}</p>
                  </div>
                </div>

                <span class="input">
                  <button
                    type="button"
                    class="button"
                    mat-raised-button
                    color="primary"
                    (click)="back()"
                  >
                    Back
                  </button>
                  <button
                    *ngIf="!isLoading"
                    type="submit"
                    [disabled]="stateForm.invalid"
                    class="button"
                    mat-raised-button
                    color="primary"
                  >
                    Save
                  </button>
                  <button
                    *ngIf="isLoading"
                    type="button"
                    [disabled]="true"
                    class="button"
                    mat-raised-button
                    color="primary"
                  >
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </button>
                </span>
              </fieldset>
            </form>
          </div>

          <div *ngSwitchCase="'edit-soc'">
            <form
              [formGroup]="stateForm"
              (ngSubmit)="onSubmit($event)"
              class="form"
            >
              <fieldset class="second">
                <legend>Soc Information</legend>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Soc</mat-label>
                    <mat-select
                      formControlName="payor_code"
                      matNativeControl
                      required
                    >
                      <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">
                        {{ soc.SOC_NAME }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>

                <span class="input">
                  <mat-form-field>
                    <mat-label>Password</mat-label>
                    <input
                      type="password"
                      formControlName="Password"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                  <div
                    *ngIf="
                      formControls.Password.invalid &&
                      (formControls.Password.touched ||
                        formControls.Password.dirty)
                    "
                    class="form-error form-username-error"
                  >
                    <div *ngIf="formControls.Password.errors.required">
                      This field required
                    </div>
                  </div>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Ref Dr</mat-label>
                    <input
                      [(ngModel)]="refDrName"
                      (ngModelChange)="refchg($event)"
                      matInput
                      [ngModelOptions]="{ standalone: true }"
                      required
                    />
                    <div class="float" style="position: relative; width: 3px">
                      <div class="ret" *ngIf="drVisible">
                        <div
                          class="list"
                          (click)="setRefDr(dr)"
                          *ngFor="let dr of searchRef"
                        >
                          {{ dr.Acount_Name }}
                        </div>
                      </div>
                    </div>
                  </mat-form-field>
                </span>
                <mat-divider></mat-divider>

                <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                    <p>{{ Errors }}</p>
                  </div>
                </div>

                <span class="input">
                  <button
                    type="button"
                    class="button"
                    mat-raised-button
                    color="primary"
                    (click)="back()"
                  >
                    Back
                  </button>
                  <button
                    *ngIf="!isLoading"
                    type="submit"
                    [disabled]="stateForm.invalid"
                    class="button"
                    mat-raised-button
                    color="primary"
                  >
                    Save
                  </button>
                  <button
                    *ngIf="isLoading"
                    type="button"
                    [disabled]="true"
                    class="button"
                    mat-raised-button
                    color="primary"
                  >
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </button>
                </span>
              </fieldset>
            </form>
          </div>
        </div>
      </app-template>
    </mat-tab>
    <mat-tab label="Create New Patient">
      <app-template [title]="'Register Patient For Billing'">
        <div class="all">
          <form
            [formGroup]="stateForm"
            (ngSubmit)="onSubmit($event)"
            class="form"
          >
            <fieldset>
              <legend>Primary Details</legend>
              <span class="input" style="position: relative">
                <div style="position: absolute; top: -50px; left: 0px">
                  {{ sex }}
                </div>
                <mat-form-field>
                  <mat-label>Title</mat-label>
                  <mat-select
                    formControlName="title_id"
                    (selectionChange)="slectOnChange($event)"
                    matNativeControl
                    required
                  >
                    <mat-option *ngFor="let title of titles" [value]="title.id">
                      {{ title.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div
                  *ngIf="
                    formControls.title_id.invalid &&
                    (formControls.first_name.touched ||
                      formControls.title_id.dirty)
                  "
                  class="form-error form-username-error"
                >
                  <div *ngIf="formControls.title_id.errors.required">
                    This field is required
                  </div>
                </div>
              </span>
              <span class="input" style="position: relative">
                <mat-form-field>
                  <mat-label>Sex</mat-label>
                  <mat-select formControlName="sex" matNativeControl required>
                    <mat-option value="Male">Male</mat-option>
                    <mat-option value="Female">Female</mat-option>
                  </mat-select>
                </mat-form-field>
                <div
                  *ngIf="
                    formControls.sex.invalid &&
                    (formControls.sex.touched || formControls.sex.dirty)
                  "
                  class="form-error form-username-error"
                >
                  <div *ngIf="formControls.sex.errors.required">
                    This field required
                  </div>
                </div>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Name</mat-label>
                  <input formControlName="first_name" matInput placeholder="" />
                </mat-form-field>
                <div
                  *ngIf="
                    formControls.first_name.invalid &&
                    (formControls.first_name.touched ||
                      formControls.first_name.dirty)
                  "
                  class="form-error form-username-error"
                >
                  <div *ngIf="formControls.first_name.errors.required">
                    This field is required
                  </div>
                </div>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Guardian Name</mat-label>
                  <input
                    formControlName="father_name"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <!-- <span class="input">
                          <mat-form-field>
                              <mat-label>Sex</mat-label>
                              <mat-select formControlName="sex" matNativeControl required>
                                <mat-option  value="M">Male</mat-option>
                                <mat-option value="F">Female</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div *ngIf="formControls.sex.invalid && (formControls.sex.touched || formControls.sex.dirty)" class="form-error form-username-error">
                              <div *ngIf="formControls.sex.errors.required">
                                This field required
                              </div>
                            </div>
                        </span> -->
              <span class="input">
                <mat-form-field>
                  <mat-label>Marital Status</mat-label>
                  <mat-select
                    formControlName="marital_status"
                    matNativeControl
                    required
                  >
                    <mat-option value="Married">Married</mat-option>
                    <mat-option value="Unmarried">Unmarried</mat-option>
                  </mat-select>
                </mat-form-field>
                <div
                  *ngIf="
                    formControls.marital_status.invalid &&
                    (formControls.marital_status.touched ||
                      formControls.marital_status.dirty)
                  "
                  class="form-error form-username-error"
                >
                  <div *ngIf="formControls.marital_status.errors.required">
                    This field required
                  </div>
                </div>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Branch Code</mat-label>
                  <mat-select formControlName="Branch_Code" matNativeControl>
                    <mat-option
                      *ngFor="let Branch of Branches"
                      [value]="Branch.Branch_Code"
                    >
                      {{ Branch.Branch_Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Blood Group</mat-label>
                  <input formControlName="bloodgroup" matInput placeholder="" />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Date Of Birth</mat-label>
                  <input
                    formControlName="date_of_birth"
                    (dateChange)="DateChange($event)"
                    matInput
                    [matDatepicker]="picker3"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker3"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
                <!-- <input type="date" formControlName="date_of_birth" placeholder="date of birth" (ngModelChange)="DateChange($event)"> -->
              </span>
              <span class="input" style="position: relative">
                <mat-form-field>
                  <mat-label>Age</mat-label>
                  <input
                    formControlName="age"
                    (change)="onChange($event)"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Age(day)</mat-label>
                  <input
                    formControlName="ageDays"
                    type="number"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Age(month)</mat-label>
                  <input
                    formControlName="ageMonth"
                    type="number"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Address One</mat-label>
                  <input
                    formControlName="local_address1"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Address Two</mat-label>
                  <input
                    formControlName="local_address2"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>City</mat-label>
                  <mat-select formControlName="local_city" matNativeControl>
                    <mat-option *ngFor="let city of cities" [value]="city.name">
                      {{ city.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>State</mat-label>
                  <mat-select formControlName="local_state" matNativeControl>
                    <mat-option
                      *ngFor="let state of states"
                      [value]="state.name"
                    >
                      {{ state.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="local_country" matNativeControl>
                    <mat-option
                      *ngFor="let country of countries"
                      [value]="country.name"
                    >
                      {{ country.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Nationality</mat-label>
                  <mat-select formControlName="nationality" matNativeControl>
                    <mat-option
                      *ngFor="let nation of nations"
                      [value]="nation.name"
                    >
                      {{ nation.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Mobile No</mat-label>
                  <input
                    formControlName="mobile"
                    matInput
                    placeholder=""
                    required
                  />
                </mat-form-field>
                <div
                  *ngIf="
                    formControls.mobile.invalid &&
                    (formControls.mobile.touched || formControls.mobile.dirty)
                  "
                  class="form-error form-username-error"
                >
                  <div *ngIf="formControls.mobile.errors.required">
                    This field required
                  </div>
                </div>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input
                    formControlName="E_mail_address"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Birth Country</mat-label>
                  <input
                    formControlName="country_of_birth"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <!-- <span class="input">
                        <mat-form-field>
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="status" matNativeControl>
                              <mat-option  value="Active">Active</mat-option>
                              <mat-option value="Inactive">Inactive</mat-option>
                            </mat-select>
                          </mat-form-field>
                      </span> -->
              <span class="input">
                <mat-form-field>
                  <mat-label>Booking Number</mat-label>
                  <input
                    type="number"
                    formControlName="booking_number"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Bar Code</mat-label>
                  <mat-select formControlName="Barcode_No" matNativeControl>
                    <mat-option
                      *ngFor="let code of barCodes"
                      [value]="code.barcode_no"
                    >
                      {{ code.barcode_no }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>No. of children</mat-label>
                  <input
                    type="number"
                    formControlName="numberOfChildren"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Occupation</mat-label>
                  <input
                    type="text"
                    formControlName="occupation_code"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
              </span>
            </fieldset>

            <fieldset class="second">
              <legend>Other Information</legend>
              <span class="input">
                <mat-form-field>
                  <mat-label>Soc</mat-label>
                  <mat-select
                    formControlName="payor_code"
                    matNativeControl
                    required
                  >
                    <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">
                      {{ soc.SOC_NAME }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <!-- <span class="input">
                          <mat-form-field>
                              <mat-label>Car Per</mat-label>
                              <input formControlName="card_per" matInput placeholder="">
                            </mat-form-field>
                        </span> -->

              <span class="input">
                <mat-form-field>
                  <mat-label>Password</mat-label>
                  <input
                    type="password"
                    formControlName="Password"
                    matInput
                    placeholder=""
                  />
                </mat-form-field>
                <div
                  *ngIf="
                    formControls.Password.invalid &&
                    (formControls.Password.touched ||
                      formControls.Password.dirty)
                  "
                  class="form-error form-username-error"
                >
                  <div *ngIf="formControls.Password.errors.required">
                    This field required
                  </div>
                </div>
              </span>
              <span class="input">
                <mat-form-field>
                  <mat-label>Ref Dr</mat-label>
                  <input
                    [(ngModel)]="refDrName"
                    (ngModelChange)="refchg($event)"
                    matInput
                    [ngModelOptions]="{ standalone: true }"
                    required
                  />
                  <div class="float" style="position: relative; width: 3px">
                    <div class="ret" *ngIf="drVisible">
                      <div class="list" *ngIf="refLoad">Loading</div>
                      <div
                        class="list"
                        (click)="setRefDr(dr)"
                        *ngFor="let dr of searchRef"
                      >
                        {{ dr.Acount_Name }}
                      </div>
                    </div>
                  </div>
                </mat-form-field>
              </span>
              <button
                type="button"
                (click)="refresh()"
                class="button"
                mat-raised-button
                color="primary"
              >
                Refresh
              </button>
              <mat-divider></mat-divider>

              <div class="errorMessage">
                <div *ngIf="Errors" class="error">
                  <p>{{ Errors }}</p>
                </div>
              </div>

              <span class="input">
                <button
                  *ngIf="!isLoading"
                  type="submit"
                  [disabled]="stateForm.invalid"
                  class="button"
                  mat-raised-button
                  color="primary"
                >
                  Save
                </button>
                <button
                  *ngIf="isLoading"
                  type="button"
                  [disabled]="stateForm.invalid"
                  class="button"
                  mat-raised-button
                  color="primary"
                >
                  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </button>
              </span>
            </fieldset>
          </form>
        </div>
      </app-template>
    </mat-tab>
  </mat-tab-group>
</div>
